export default __webpack_public_path__ + "static/media/multiasset-banner.b9365617.jpg";